/**
 * Arrivée depuis le résumé du lundi : les liens du mail portent
 * `wd=<semaine>~<endroit>~<ligne>` (functions/weeklyDigest/renderDigestEmail.js),
 * sans aucun identifiant de personne.
 *
 * Au chargement de l'app, avant que le routeur lise l'adresse, la marque est
 * retirée (une adresse partagée ou rechargée ne compte pas deux fois), puis
 * envoyée une seule fois, une fois connecté, au callable `handleWeeklyDigest`
 * (action `click`) qui ajoute un au compteur anonyme du parc. Jamais en mode
 * démo ; un échec ne gêne jamais la navigation.
 */
export const WEEKLY_DIGEST_PARAM = "wd";
const REF = /^\d{4}-W\d{2}~[a-z]+~[A-Za-z-]{1,48}$/;

/** Lit et retire la marque de l'adresse courante ; null si absente ou illisible. */
export function takeWeeklyDigestRef(win = typeof window === "undefined" ? null : window) {
  if (!win?.location || !win.history?.replaceState) return null;
  let url;
  try {
    url = new URL(win.location.href);
  } catch (_) {
    return null;
  }
  if (!url.searchParams.has(WEEKLY_DIGEST_PARAM)) return null;
  const ref = url.searchParams.get(WEEKLY_DIGEST_PARAM);
  url.searchParams.delete(WEEKLY_DIGEST_PARAM);
  try {
    win.history.replaceState(win.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch (_) {}
  return REF.test(ref || "") ? ref : null;
}

/** Envoie la marque au serveur (une fois) ; ne lève jamais. */
export async function reportWeeklyDigestArrival(ref, { getFunctions, isDemo = () => false } = {}) {
  if (!ref || !REF.test(ref) || isDemo()) return false;
  try {
    const callable = (await getFunctions()).httpsCallable("handleWeeklyDigest");
    await callable({ action: "click", ref });
    return true;
  } catch (_) {
    return false;
  }
}
